/* eslint-disable no-unused-vars */
export enum WebhookTypeEnum {
  Template = 0,
  Image,
}
